import StepSsoProfessionalSection from "./StepSsoProfessionalSection";
import StepSsoOauthLoginPresetPicker, { type SsoOauthLoginPresetRow } from "./StepSsoOauthLoginPresetPicker";

type Props = {
	showSsoProfessionalBlock: boolean;
	showSsoOauthLoginPresetPicker: boolean;
	ssoOauthLoginPresets: readonly SsoOauthLoginPresetRow[];
	ssoOauthLoginPresetSectionTitle: string;
	ssoProTitle: string;
	ssoProCta: string;
	onSsoProfessionalClick: () => void;
	onSsoOauthLoginPresetEmail: (email: string) => void | Promise<void>;
};

export default function StepEmailProAuthBlocks(props: Props): React.JSX.Element {
	const {
		showSsoProfessionalBlock,
		showSsoOauthLoginPresetPicker,
		ssoOauthLoginPresets,
		ssoOauthLoginPresetSectionTitle,
		ssoProTitle,
		ssoProCta,
		onSsoProfessionalClick,
		onSsoOauthLoginPresetEmail,
	} = props;

	return (
		<>
			{showSsoOauthLoginPresetPicker && (
				<StepSsoOauthLoginPresetPicker
					title={ssoOauthLoginPresetSectionTitle}
					presets={ssoOauthLoginPresets}
					onAccountEmail={onSsoOauthLoginPresetEmail}
				/>
			)}
			{showSsoProfessionalBlock && (
				<StepSsoProfessionalSection title={ssoProTitle} cta={ssoProCta} onClick={onSsoProfessionalClick} />
			)}
		</>
	);
}
